export default {
  desktop: {
    pageName: {
      max: 200,
    },
    name: {
      max: 30,
    },
    sku: {
      max: 30,
    },
    intro: {
      max: 30,
    },
    price: {
      max: 30,
    },
    button: {
      max: 30,
    },
    badge: {
      max: 30,
    },
  },
  tablet: {
    pageName: {
      max: 200,
    },
    name: {
      max: 16,
    },
    sku: {
      max: 14,
    },
    intro: {
      max: 14,
    },
    price: {
      max: 16,
    },
    button: {
      max: 16,
    },
    badge: {
      max: 14,
    },
  },
  mobile: {
    pageName: {
      max: 50,
    },
    name: {
      max: 16,
    },
    sku: {
      max: 14,
    },
    intro: {
      max: 14,
    },
    price: {
      max: 16,
    },
    button: {
      max: 16,
    },
    badge: {
      max: 14,
    },
  },
};
